import graphqlRequest from "Services/assignment/assignmentRequest";
import UPDATE_BATCH_ASSIGNMENTS from "./graphql";

export async function updateBatchAssignments(input) {
  const response = await graphqlRequest(UPDATE_BATCH_ASSIGNMENTS, {input});
  return response
}
